import { Header } from "components/header";
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";

import DollarWEBP from "assets/bgDollar.webp";
import Dollar from "assets/bgDollar.jpg";
import ManWEBP from "assets/bgMan.webp";
import Man from "assets/bgMan.jpg";
import LoadingSpinner from "components/loading-spinner";
import ImpressumFooter from "components/footer-impressum";

export default function DropoffSellerForm() {
  const [sidebarVisual, setSidebarVisual] = useState("man");
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen">
      <Header showSupport={true} />
      {isLoading && <LoadingSpinner isLoading={isLoading} />}
      <div className={`md:overflow-hidden ${isLoading ? `hidden` : `flex`}`}>
        <div
          className={`w-screen min-h-[calc(100vh-81px)] md:h-[calc(100vh-81px)] flex flex-col justify-between md:overflow-scroll`}
        >
          <Outlet
            context={{
              setSidebarVisual,
              setIsLoading,
            }}
          />
        </div>
        <div
          className={`hidden lg:block w-full max-w-[588px] h-[calc(100vh-81px)] relative`}
        >
          {sidebarVisual === "dollar" ? (
            <picture className="absolute left-0 top-0 h-full w-full -z-10">
              <source
                type="image/webp"
                srcSet={DollarWEBP}
                className="h-full object-cover w-full"
              />
              <img
                src={Dollar}
                alt="A dollar sign made out of LEGO bricks"
                className="h-full object-cover w-full"
              />
            </picture>
          ) : sidebarVisual === "man" ? (
            <picture className="absolute left-0 top-0 h-full w-full -z-10">
              <source
                type="image/webp"
                srcSet={ManWEBP}
                className="h-full object-cover w-full"
              />
              <img
                src={Man}
                alt="A smiling LEGO figure holding a megaphone"
                className="h-full object-cover w-full"
              />
            </picture>
          ) : null}
        </div>
      </div>
      <ImpressumFooter className="" />
    </div>
  );
}
